import { render } from "./widget-notebook-ge.vue?vue&type=template&id=2dab6b81"
import script from "./widget-notebook-ge.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-notebook-ge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-notebook-ge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dab6b81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dab6b81', __exports__)) {
    api.reload('2dab6b81', __exports__)
  }
  
  module.hot.accept("./widget-notebook-ge.vue?vue&type=template&id=2dab6b81", () => {
    api.rerender('2dab6b81', render)
  })

}


export default __exports__